(() => {
  const COLOR_RE = /(renk|color|colour)/i;
  const QTY_RE = /(adet|miktar|paket|quantity|qty)/i;

  const normalize = (value) =>
    String(value ?? '')
      .trim()
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ');

  const parseMap = (picker) => {
    const script = picker?.querySelector('[data-plexigo-color-media-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.error('[PlexiGo] Renk-medya haritası okunamadı:', error);
      return null;
    }
  };

  const optionGroups = (picker) =>
    Array.from(picker?.querySelectorAll('fieldset, .product-form__input--dropdown') || []);

  const groupName = (group) => {
    const input = group?.querySelector('input:checked, select option:checked');
    if (input?.dataset?.optionName) return input.dataset.optionName;
    const legend = group?.querySelector('legend, label.form__label');
    return legend?.textContent?.replace(':', '').trim() || '';
  };

  const groupValue = (group) => {
    const checked = group?.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = group?.querySelector('select');
    return select?.value ?? '';
  };

  const getColor = (picker, map) => {
    const groups = optionGroups(picker);
    const mappedIndex = Number(map?.color_position || 0) - 1;
    if (mappedIndex >= 0 && groups[mappedIndex]) return groupValue(groups[mappedIndex]);

    const colorGroup = groups.find((group) => COLOR_RE.test(groupName(group)));
    if (colorGroup) return groupValue(colorGroup);

    const visualGroup = groups.find((group) => !QTY_RE.test(groupName(group)));
    return visualGroup ? groupValue(visualGroup) : groupValue(groups[0]);
  };

  const mediaFromColorMap = (map, color) => {
    if (!Array.isArray(map?.colors) || !color) return null;
    const wanted = normalize(color);
    const match = map.colors.find((entry) => normalize(entry?.value) === wanted && entry?.media_id);
    return match?.media_id || null;
  };

  const mediaFromVariantFallback = (map, color) => {
    if (!Array.isArray(map?.variant_media) || !color) return null;
    const colorIndex = Math.max(0, Number(map?.color_position || 1) - 1);
    const wanted = normalize(color);
    const match = map.variant_media.find(
      (variant) => variant?.media_id && normalize(variant.options?.[colorIndex]) === wanted,
    );
    return match?.media_id || null;
  };

  const forceActivate = (productInfo, mediaId) => {
    if (!productInfo || !mediaId) return false;
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return false;

    const sectionId = productInfo.dataset.section;
    const targetId = `${sectionId}-${mediaId}`;
    const target = gallery.querySelector(`[data-media-id="${targetId}"]`);

    if (!target) {
      console.warn('[PlexiGo] Renk görseli galeride bulunamadı:', { mediaId, targetId });
      return false;
    }

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetId, true);
    } else {
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.remove('is-active'));
      target.classList.add('is-active');
      target.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }

    return true;
  };

  const sync = (productInfo) => {
    if (!productInfo) return false;
    const picker = productInfo.querySelector('variant-selects');
    if (!picker) return false;

    const map = parseMap(picker);
    if (!map) return false;

    const color = getColor(picker, map);
    const mediaId = mediaFromColorMap(map, color) || mediaFromVariantFallback(map, color);
    if (!mediaId) {
      console.info('[PlexiGo] Bu renk için eşleşen ürün görseli bulunamadı:', {
        product: picker.dataset.productHandle,
        color,
      });
      return false;
    }

    return forceActivate(productInfo, mediaId);
  };

  const syncWithRetries = (productInfo) => {
    [0, 80, 220, 500].forEach((delay) => window.setTimeout(() => sync(productInfo), delay));
  };

  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-selects');
    if (!picker) return;
    const productInfo = picker.closest('product-info');
    if (productInfo) syncWithRetries(productInfo);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const sectionId = data?.sectionId;
      const productInfo = sectionId
        ? document.querySelector(`product-info[data-section="${String(sectionId)}"]`)
        : document.querySelector('product-info');
      if (productInfo) syncWithRetries(productInfo);
    });
  }

  document.addEventListener('product-info:loaded', (event) => {
    const productInfo = event.target?.closest?.('product-info') || event.target;
    if (productInfo?.matches?.('product-info')) syncWithRetries(productInfo);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-info').forEach((productInfo) => syncWithRetries(productInfo));
  });
})();
